export const TOP_STATS_TABLE_PAGE_SIZE = 50
